import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ErrorService, SpinnerService } from '@eforall/common';
import { fromEvent, map } from 'rxjs';
import { EmulateTouchPanningService } from '../../services/emulate-touch-panning-service';
import { MobileLayoutPart } from './layout/mobile-layout.part';
import { MobileLayoutService } from './layout/mobile-layout.service';


@Component({
	selector: 'mobile-frame',
	standalone: true,
	imports: [
		CommonModule,
		MobileLayoutPart,
	],
	templateUrl: './mobile.frame.html',
	styleUrls: ['./mobile.frame.scss']
})
export class MobileFrame {

	public errorService = inject(ErrorService);
	public spinner = inject(SpinnerService);
	public layout = inject(MobileLayoutService);
	public touchService = inject(EmulateTouchPanningService);

	private readonly elementRef = inject(ElementRef);

	public readonly mousePosition = toSignal(
		fromEvent<MouseEvent>(this.elementRef.nativeElement, 'pointermove').pipe(
			map(event => ({ x: event.clientX, y: event.clientY }))
		),
		{ initialValue: { x: 0, y: 0 } }
	);

	/**
	 * Moves the Emulated Touch Cursor around
	 */
	public readonly cursorTransform = computed<string>(() => {
		const CENTER = 15;	// Circle is 30x30
		const pos = this.mousePosition();
		return `translate(${pos.x - CENTER}px,${pos.y - CENTER}px)`;
	})


	/**
	 * If true, the menu and footer nav will not be displayed. Default we set it to false
	 */
	public readonly restrictNavigation = input(false);

	public cssClass = computed(() =>

		this.layout.dimensions().breakpoint == 'wide-computer' ? 'mobile-frame computer-mobile-frame wide-computer' :
			this.layout.dimensions().breakpoint == 'computer' ?
				'mobile-frame computer-mobile-frame' : this.layout.dimensions().breakpoint == 'tablet' ?
					'mobile-frame tablet-mobile-frame' : 'mobile-frame phone-mobile-frame'
	);

}
